import React, { useState } from "react";
import Carousel from "../components/Carousel";
import { useFirebase } from "../providers/firebase";
import { useAuthentication } from "../providers/authentication";

const PhotosPage = () => {
  const { user } = useAuthentication();

  const { uploadImage, addPhoto } = useFirebase();
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUploadPhoto = async () => {
    if (!selectedFile) return;

    setUploading(true);
    try {
      const photoURL = await uploadImage(selectedFile);
      console.log("Photo uploaded successfully: ", photoURL);
      addPhoto(photoURL, 'photos').then(()=> window.location.reload());
    } catch (error) {
      console.error("Error uploading photo: ", error);
    } finally {
      setUploading(false);
      setSelectedFile(null);
    }
  };

  return (
    <>
      <div className="photos-container">
        <div className="photos-page-container">
          <div className="photos-heading">Photos</div>

          {/* File Input and Upload Button */}
          {user && (
            <div className="upload-photo-container">
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="photo-input"
              />
              <button
                onClick={handleUploadPhoto}
                className="upload-photo-button"
                disabled={uploading}
                style={{
                  color: "white",
                  backgroundColor: "red",
                  border: "none",
                }}
              >
                {uploading ? "Uploading..." : "Upload Photo"}
              </button>
            </div>
          )}

          <Carousel />
        </div>

        <div className="copyright-bar">
          (c) All Rights Reserved by VSIMA Lab, SECS, IIT Bhubaneswar, 2024
        </div>
      </div>
    </>
  );
};

export default PhotosPage;
